import { supabase } from '../lib/supabase';
import axios from 'axios';

export const inventoryUploadService = {
  async uploadFile(file, jobType, onProgress) {

    
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      throw new Error('User not authenticated');
    }

    const formData = new FormData();
    formData.append('file', file);

    const endpoint = jobType === 'products' ? '/api/v1/product-uploads/upload' : '/api/v1/component-uploads/';
    
    try {
      const response = await axios.post(endpoint, formData, {
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percentCompleted);
          }
        },
        // Large bundles need long timeouts
        timeout: 300000 
      });


      return response.data;
    } catch (err) {
      console.error('[UPLOAD_SERVICE] Axios exception:', err);
      
      let errorMessage = 'Upload failed';
      if (err.response) {
        // Server responded with non-2xx
        console.error('[UPLOAD_SERVICE] API Error Data:', err.response.data);
        errorMessage = err.response.data.detail || err.response.data.message || errorMessage;
      } else if (err.request) {
        // Request made but no response (timeout, etc)
        errorMessage = 'No response from server. Connection may have timed out during scanning.';
      } else {
        errorMessage = err.message;
      }
      
      throw new Error(errorMessage);
    }
  }
};
